const registrationFields = [
  'vat_registered', 'in_company_register', 'in_foundation_register',
  'in_voluntary_register', 'in_party_register',
];

export function hasFilterValue(value: unknown): boolean {
  return value !== '' && value !== null && value !== undefined;
}

export function registrationFilterCount(criteria: Record<string, unknown>): number {
  return registrationFields.filter(field => criteria[field] === true).length;
}

export function numericFilterCount(criteria: Record<string, unknown>, fields: string[]): number {
  return fields.filter(field => {
    const comparison = criteria[field] as {operator?: string; value?: unknown; min?: unknown; max?: unknown} | undefined;
    if (!comparison) return false;
    // Include unfinished ranges so entered values are never hidden without an indicator.
    return comparison.operator === 'between'
      ? hasFilterValue(comparison.min) || hasFilterValue(comparison.max)
      : hasFilterValue(comparison.value);
  }).length;
}
